import React from 'react';
import { motion } from 'framer-motion';
const steps = ['Canvass neighborhoods & knock doors with a proven script', 'Talk to homeowners & book appointments for our project consultants', "Get a full week of hands-on field training with a leader who's done it", 'Goal: your first deal in your first week', 'Weekly local + national coaching to sharpen your skills'];
export function TheRole() {
  return <section className="py-20 bg-off-white" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-148">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-149">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal mb-6" data-id="element-150">
              The Role: Field Rep
            </h2>
            <p className="text-xl text-gray-700 leading-relaxed mb-8" data-id="element-151">
              You'll start as a field rep, learning how to canvas neighborhoods,
              knock doors, talk to homeowners, and help them schedule time to
              meet with one of our project consultants.
            </p>

            <div className="bg-maroon/10 border-l-4 border-maroon p-6 rounded" data-id="element-152">
              <p className="text-lg font-semibold text-charcoal" data-id="element-153">
                You won't be winging it. We've built the systems, the support,
                and the leadership.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-154">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3 + index * 0.1
          }} className="flex items-start space-x-4" data-id="element-155">
                <div className="flex-shrink-0 w-10 h-10 bg-maroon rounded-full flex items-center justify-center" data-id="element-156">
                  <span className="text-white font-bold text-lg" data-id="element-157">
                    {index + 1}
                  </span>
                </div>
                <div className="flex-1 pt-1" data-id="element-158">
                  <p className="text-lg text-gray-800" data-id="element-159">{step}</p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}